export const getAuthToken = () => {
  if (localStorage.getItem('admin_token')) {
    return localStorage.getItem('admin_token')
  }
  return ''
}

export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem('admin_token', token)
  }
}

export const isLogin = () => {
  if (localStorage.getItem('admin_token')) {
    return true
  }
  return false
}


export const setTheme = async (theme) => {
  if (theme == 'dark') {
      document.body.classList.add('light_theme');
  } else {
      document.body.classList.remove('light_theme');
  }
  localStorage.setItem('theme', theme);
  return theme
}



export const getTheme = () => {
  let theme = localStorage.getItem('theme');
  if (theme) {
      return theme
  }
  return 'dark'
}